import React from 'react';

import { SimpleModal } from '../../../../../components/simple-modal/simple-modal';
import { OrderDocumentUploadForm } from './order-document-upload-form';
import { DocumentUploadForm } from './document-upload-form';
import { messages } from './messages';

type CustomsDocumentUploadModalProps = {
  onClose: () => void;
  availableDocumentTypes: string[];
  salesOrderId?: string;
  shipmentId?: string;
  isSending?: boolean;
  onSubmit?: () => void;
  onRefresh?: () => void;
  isDisabled?: boolean;
  carrierCode?: string | null;
  trackingNumber?: string | null;
};

/**
 * Modal wrapper for customs document upload.
 *
 * Renders `OrderDocumentUploadForm` when `salesOrderId` is provided (pre-ship),
 * or `DocumentUploadForm` when `shipmentId` is provided (post-ship).
 */
export const CustomsDocumentUploadModal = ({
  onClose,
  availableDocumentTypes,
  salesOrderId,
  shipmentId,
  isSending,
  onSubmit,
  onRefresh,
  isDisabled,
  carrierCode,
  trackingNumber,
}: CustomsDocumentUploadModalProps) => (
  <SimpleModal
    actionMessage={messages.uploadModalDoneButton}
    cancelMessage={messages.uploadModalCancelButton}
    headerMessage={messages.uploadModalTitle}
    onAction={onClose}
    onCancel={onClose}
    onClose={onClose}
    size='medium'
  >
    {salesOrderId && (
      <OrderDocumentUploadForm
        availableDocumentTypes={availableDocumentTypes}
        initialState='ready'
        isDisabled={isDisabled}
        onRefresh={onRefresh}
        salesOrderId={salesOrderId}
      />
    )}
    {shipmentId && (
      <DocumentUploadForm
        availableDocumentTypes={availableDocumentTypes}
        carrierCode={carrierCode}
        initialState='ready'
        isDisabled={isDisabled}
        isSending={isSending}
        onRefresh={onRefresh}
        onSubmit={onSubmit}
        shipmentId={shipmentId}
        trackingNumber={trackingNumber}
      />
    )}
  </SimpleModal>
);
